import { Injector, Pipe, PipeTransform } from '@angular/core';

import { DateFormatter } from '../helper';

@Pipe({
  standalone: true,
  name: 'dateFormatter',
})
export class DateFormatterPipe implements PipeTransform {
  constructor(private injector: Injector) {}
  transform(date: string | Date, options ?: object , ...args): string {
    return DateFormatter(this.injector, date, options);
  }
}
